import React from "react";
import HomeCarousel from "../../Component/HomeCarouselComponent";
import { Helmet } from "react-helmet-async";
import { CameraIcon } from "@heroicons/react/solid";
import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/outline'
import CustomButton from "../../Component/customButton";


const faqs = [
    {
      question: "What happens in the weather is Poor ?",
      answer:
        "Ballooning is subject to suitable weather. If your flight is cancelled because of poor weather, you will be re-booked on a later flight If possible, otherwise your money will be refunded.",
    },
    {
        question: "Why is a balloon Safari so Expensive ?",
        answer:
          "Balloon flights are expensive to operate, especially in remote areas such as Serengeti National Park. Balloons -naturally- need to be in top condition, so they need to be replaced after about 850 flight hours. One balloon costs more than US$ 100,000. One also needs to consider the cost of fuel and crew to operate the balloon flight. Each crew comprises six people plus a licensed pilot. A further ten people (per balloon) operate behind the scenes to get the balloon airborne. So this adds up to a considerable amount of people. Additionally, there are the recovery vehicles, transfer vehicles, and backup operations. Last, a substantial part of the total price is allocated to conservation fees.",
      },
    // More questions...
  ]  

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

const HotAirballoonPage = () => {
  return (
    <>
      <HomeCarousel
        image_url={[
          "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/hot-air-ballon-serengeti-carousel.jpg",
          "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/cheetah1.jpg",
          "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/resania_car_traveller.webp",
          "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/Kilimanjaro/climbing-kilimanjaro.webp",
          "https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/HotelZanzibar/beach.webp",
          'https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/ndarakwai-carousel.webp'
  ]}
        title1="Hot Air Balloon Over Serengeti"
        button_text="Help Me Plan"
        description="A Serengeti balloon safari is the ultimate way to experience the vastness of the national park"
        link="/resania/help-plan"
      />
      <Helmet>
        <title>Hot Air Balloon Over Savannah | Serengeti</title>
        <meta
          name="description"
          content="A Serengeti balloon safari is the ultimate way to experience the vastness of the national park."
        />
        <meta
          name="keywords"
          content="Serengeti, Safari Africa, Tanzania, Ngorongoro, Resa Africa, Big Five, Africa Great Migration"
        />
      </Helmet>
      
      <div className=" overflow-hidden">
        <div className="relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
          <div className="hidden lg:block dark:bg-gray-700 bg-gray-50 absolute top-0 bottom-0 left-3/4 w-screen" />
          <div className="mx-auto text-base max-w-prose lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-none">
            <div>
              <h2 className="text-base text-yellow-700 font-semibold tracking-wide uppercase">
                ultimate Experience
              </h2>
              <h3 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                Hot Air Balloon Over Savannah
              </h3>
            </div>
          </div>
          <div className="mt-8 lg:grid lg:grid-cols-2 lg:gap-8">
            <div className="relative lg:row-start-1 lg:col-start-2">
              <svg
                className="hidden lg:block absolute top-0 right-0 -mt-20 -mr-20"
                width={404}
                height={384}
                fill="none"
                viewBox="0 0 404 384"
                aria-hidden="true"
              >
                <defs>
                  <pattern
                    id="de316486-4a29-4312-bdfc-fbce2132a2c1"
                    x={0}
                    y={0}
                    width={20}
                    height={20}
                    patternUnits="userSpaceOnUse"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={4}
                      height={4}
                      className="text-gray-200"
                      fill="currentColor"
                    />
                  </pattern>
                </defs>
                <rect
                  width={404}
                  height={384}
                  fill="url(#de316486-4a29-4312-bdfc-fbce2132a2c1)"
                />
              </svg>
              <div className="relative text-base mx-auto max-w-prose lg:max-w-none">
                <figure>
                  <div className="aspect-w-12 aspect-h-7 lg:aspect-none">
                    <img alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                      className="rounded-lg shadow-lg object-cover object-center"
                      src="https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/parks-picture/balloon-safari-serengeti-small.jpg"
                      width={1184}
                      height={1376}
                    />
                  </div>
                  <figcaption className="mt-3 flex text-sm text-gray-500">
                    <CameraIcon
                      className="flex-none w-5 h-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </figcaption>
                </figure>
              </div>
            </div>
            <div className="mt-8 lg:mt-0">
              <div className="text-base max-w-prose mx-auto lg:max-w-none">
                <p className=" mt-6 leading-8 text-lg dark:text-gray-200">
                  <strong className="text-color">
                    A Serengeti balloon safari is the ultimate way to experience
                    the vastness of the national park.
                  </strong>
                </p>
              </div>
              <div className="mt-5 prose prose-yellow text-gray-500 mx-auto lg:max-w-none lg:row-start-1 lg:col-start-1">
                <p className=" mt-6 leading-8 text-lg dark:text-gray-200">
                  Just imagine floating above the Serengeti plains skimming
                  treetops in complete silence whilst seeing wildlife on the
                  ground below. This is an essential safari experience for
                  travellers to Serengeti National Park.
                </p>
                <h3 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl dark:text-gray-200">
                  Flights Locations
                </h3>
                <p className=" mt-6 leading-8 text-lg dark:text-gray-200">
                  Balloon flights are run daily at 06h00 from four launch sites
                  within Serengeti National Park: one throughout the year close
                  to Seronera, and others in the Ndutu area (from 25 December to
                  15 March), in the Western Corridor (from June to October), and
                  in northern Serengeti (from July to October).
                </p>
                <h3 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl dark:text-gray-200">
                  The Experience
                </h3>
                <p className=" mt-6 leading-8 text-lg dark:text-gray-200">
                  Although not cheap, a balloon safaris is worth the expense.
                  Floating serenely over the treetops as the sun peaks over the
                  horizon permits you to experience the endless Serengeti plains
                  from an unforgettable perspective. As we set departure very
                  early morning, you may even spot some nocturnal predators
                  getting ready for the day.
                </p>
                <p className=" mt-6 leading-8 text-lg dark:text-gray-200">
                  During most flights the pilot will include sections flown at a
                  higher altitude allowing you to soak up uninterrupted views of
                  the Serengeti; other sections may involve low-level flying,
                  during which there may be the opportunity to see wildlife.
                  Highly experienced pilots can follow rivers and streams, and
                  will glide just meters above grunting hippos or wandering
                  giraffes. Flying low allows you to take some great aerial
                  wildlife photos. You move over the plains wherever the wind
                  takes you, whilst being tracked from the ground by balloon
                  crew in their vehicles.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-8 lg:grid lg:grid-cols-2 lg:gap-8">
            <div className="relative lg:row-start-1 lg:col-start-2">
              <svg
                className="hidden lg:block absolute top-0 right-0 -mt-20 -mr-20"
                width={404}
                height={384}
                fill="none"
                viewBox="0 0 404 384"
                aria-hidden="true"
              >
                <defs>
                  <pattern
                    id="de316486-4a29-4312-bdfc-fbce2132a2c1"
                    x={0}
                    y={0}
                    width={20}
                    height={20}
                    patternUnits="userSpaceOnUse"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={4}
                      height={4}
                      className="text-gray-200"
                      fill="currentColor"
                    />
                  </pattern>
                </defs>
                <rect
                  width={404}
                  height={384}
                  fill="url(#de316486-4a29-4312-bdfc-fbce2132a2c1)"
                />
              </svg>
              <div className="relative text-base mx-auto max-w-prose lg:max-w-none">
                <figure>
                  <div className="aspect-w-12 aspect-h-7 lg:aspect-none">
                    <img alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                      className="rounded-lg shadow-lg object-cover object-center"
                      src="https://resania-static-space.ams3.digitaloceanspaces.com/resania-static/img/parks-picture/serengeti_balloon_safari.jpg"
                      width={1184}
                      height={1376}
                    />
                  </div>
                  <figcaption className="mt-3 flex text-sm text-gray-500">
                    <CameraIcon
                      className="flex-none w-5 h-5 text-gray-400"
                      aria-hidden="true"
                    />
                    <span className="ml-2">
                      Hot air Balloon & Great Migration
                    </span>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div className="mt-8 lg:mt-0">
              <h3 className="mt-2 text-2xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-3xl">
                Hot air Ballooning & Great Migration
              </h3>

              <div className="mt-5 prose prose-yellow text-gray-500 mx-auto lg:max-w-none lg:row-start-1 lg:col-start-1">
                <p className=" mt-6 leading-8 text-lg dark:text-gray-200">
                  The best odds for seeing the Great Migration with its
                  innumerable wildebeest and zebra would be to book a flight in
                  the Ndutu area as large herds congregate here between December
                  and March. The other locations may also allow you to see the
                  Great Migration from above, but please remember the herd is
                  mobile and may only be in a particular area for a brief
                  period, if not just a couple of days. This means that some
                  luck needs to be on your side.
                </p>
                <h3 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 dark:text-gray-200 sm:text-4xl">
                  Serengeti Hot air Balloon flight price
                </h3>
                <p className=" mt-6 leading-8 text-lg dark:text-gray-200">
                  A Serengeti balloon flight costs US$ 550 per person (this
                  includes the Tanapa ballooning fee of US$ 40). This rate
                  includes a transfer from your lodge or camp to the departure
                  balloon site, the balloon flight itself, and a champagne
                  breakfast (after landing). The flight will last anything in
                  between 50 and 70 minutes. Depending on the landing site, also
                  the breakfast site is set up at a different location daily.
                  You will share the balloon with up to 16 passengers in total.
                </p>
              </div>
            </div>
          </div>
          <div className="relative dark:bg-gray-700 overflow-hidden mt-10">
            <div className="relative px-4 sm:px-6 lg:px-8">
              <div className="text-lg max-w-5xl mx-auto mb-8">
                <h1 className="mb-8">
                  <span className="block text-base text-center text-green-700 font-semibold tracking-wide uppercase">
                    Planning
                  </span>
                  <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl dark:text-gray-200">
                    Planning a Balloon Safari
                  </span>
                </h1>
                <p className=" mt-6 leading-8 text-lg dark:text-gray-200">
                  Be prepared for a very early start the transfer from the
                  Seronera area leaves at 05h30 and from the other lodges in the
                  area at around 04h00. Please remember to bring some warm
                  clothing, and a bag in which you can secure camera,
                  binoculars, and other personal items. We can arrange
                  departures for a Serengeti balloon safari from most lodges and
                  camps in the Serengeti. We strongly recommend booking a
                  balloon safari in advance, as it concerns a very popular
                  activity and gets booked out early (especially during peak
                  season).
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto divide-y-2 divide-gray-200">
          <h2 className="text-center text-3xl font-extrabold text-gray-900 sm:text-4xl">Frequently asked questions</h2>
          <dl className="mt-6 space-y-6 divide-y divide-gray-200">
            {faqs.map((faq) => (
              <Disclosure as="div" key={faq.question} className="pt-6">
                {({ open }) => (
                  <>
                    <dt className="text-lg">
                      <Disclosure.Button className="text-left w-full flex justify-between items-start text-gray-400">
                        <span className="font-medium text-xl text-gray-900 dark:text-gray-300">{faq.question}</span>
                        <span className="ml-6 h-7 flex items-center">
                          <ChevronDownIcon
                            className={classNames(open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform')}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      <p className="text-base text-gray-500">{faq.answer}</p>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
      <CustomButton heading="Help Me Plan" link="/resania/help-plan" />
      <br/>
      <relatedTour/>
    </>
  );
};

export default HotAirballoonPage;
